// extracted by mini-css-extract-plugin
export var dataCell = "_ms-2";
export var dataRow = "_ms-0";
export var headerRow = "_ms-1";